export default {
  reportComponent: () => import('@/components/Tests/Report/TestReport')

}
